import SearchForm from './SearchForm'
import Router from 'next/router'
import { agriFormInputsMobile, agriFormInputs } from '@components/search/agriFormInputs'
import { AGRI_LINK_BASE } from '@constants/searchFormLinks'
import paliwo from '@components/search/inputs/paliwo'
import searchFormLink from '@utils/links/searchFormLink'

const AgriForm = ({ overrideDefaultValues }) => {
    const navigateToSearchPage = (data) => {
        const link = searchFormLink({
            data,
            linkBase: AGRI_LINK_BASE,
            isMakeModelBase: true,
        })

        Router.push(link)
    }

    return <SearchForm
        inputs={agriFormInputs}
        mobileInputs={agriFormInputsMobile}
        dataKey="agri"
        overrideDefaultValues={overrideDefaultValues}
        onSubmit={navigateToSearchPage}
        actionBar={{
            paliwo,
            clear: true,
            advancedOptions: null,
        }} />
}

export default AgriForm